// dynamicValueHelpers.js
import { valueParser, validateBlank, validateDataType } from './settings.js'
import { stepFullyConfigured } from './helpers.js'

const emptyGetter = () => null;

export function buildValueGetter(column, columnImportConfig) {
  const { data_type, is_selection } = column;

  const parseValueGetter = (params) =>
    valueParser(params.data[columnImportConfig.excel_column - 1], data_type, columnImportConfig);

  const optionGetter = (params) => {
    const parsedValue = valueParser(params.data[columnImportConfig.excel_column - 1], data_type, columnImportConfig);
    return Object.values(columnImportConfig.mapping || {}).find(item => item.from == parsedValue)?.to || '';
  };

  const defaultValueGetter = () =>
    is_selection
      ? columnImportConfig.default_value
      : valueParser(columnImportConfig.default_value, data_type, columnImportConfig);

  if (columnImportConfig.set_value === 'excel_column') {
    if (!columnImportConfig.excel_column) return emptyGetter;
    return is_selection ? optionGetter : parseValueGetter;
  }

  if (columnImportConfig.set_value === 'default_value') {
    return defaultValueGetter;
  }

  return emptyGetter;
}

export function buildCellClassRules(column, columnImportConfig) {
  return {
    'import-cell-error': (params) => {
      if (!stepFullyConfigured(columnImportConfig)) return false;
      if (columnImportConfig.set_value === 'leave_blank') return false;
      return !validateDataType(column.data_type, params.value);
    },
    'import-cell-blank': (params) => {
      if (!stepFullyConfigured(columnImportConfig)) return false;
      if (columnImportConfig.set_value === 'leave_blank') return false;
      if (columnImportConfig.ignore_blanks) return false;
      return !validateBlank(params.value);
    }
  };
}
